export default __webpack_public_path__ + "static/media/1..JPG:Zone.6ebc5938.Identifier";